import { defineMessages } from 'react-intl.macro';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import './ResourceLinkList.scss';

import { ResourceLinkData } from '../types';

const msg = defineMessages({
  moreBtn: {
    id: 'resourceLinkList.moreBtn',
    defaultMessage: 'Více...',
  },
});

type ResourceLinkListProps = {
  title: string;
  links: ResourceLinkData[];
};

export const ResourceLinkList: React.FC<ResourceLinkListProps> = ({ title, links }) => {
  const MORE_BTN_LIST_SIZE_LIMIT = 3;
  const [isExpanded, setIsExpaned] = useState(false);

  const handleMoreBtnClick = () => {
    setIsExpaned(true);
  };
  return (
    <>
      <h5 className='sg-u-type-h4'>{title}</h5>
      <ul className='sg-a-mt-1'>
        {links
          .filter((link, index) => (isExpanded ? true : index < MORE_BTN_LIST_SIZE_LIMIT))
          .map((link) => (
            <li key={link.value}>
              <RouterLink
                to={`/${link.value}`}
                className='e-resourceLinkList--link'
                title={link.label}
              >
                {link.label}
              </RouterLink>
            </li>
          ))}
      </ul>
      {links.length > MORE_BTN_LIST_SIZE_LIMIT && !isExpanded && (
        <button type='button' className='e-resourceLinkList--moreBtn' onClick={handleMoreBtnClick}>
          <FormattedMessage {...msg.moreBtn} />
        </button>
      )}
    </>
  );
};
